import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';

import { RPCFactory } from '../../../utils/RequestUtil';
import {
  BASE64_EMPTY_CHAT,
  SvgIconDownload,
  SvgFileExtIcon,
  SvgVideo,
} from './assets';

let $xhr = null;

const EMPTY_ARR = [];

const fixUrl = (str = '') => str.replace(/^https?:/, '');

const getSizeStr = (size) => {
  const ext = ['B', 'KB', 'MB', 'TB', 'PB'];
  const log = Math.floor(Math.log(size) / Math.log(1024));
  const n = +(size / Math.pow(1024, log)).toFixed(2)
  return n + ext[log];
};

const displayTime = (time) => {
  const today = moment();
  const mmt = moment(time);
  const short = mmt.format('H:mm');
  let prefix = '';
  if (today.isSame(mmt, 'day')) {
    prefix = mmt.hour() > 12 ? '下午' : '上午';
    return [prefix, short].join(' ');
  }
  const weekStart = mmt.clone().startOf('isoWeek');
  // 同一周内
  if (mmt.isAfter(weekStart)) {
    const weekStr = '日一二三四五六';
    return `周${weekStr[mmt.weekday()]} ${short}`;
  }
  return mmt.format('MM-DD HH:mm:ss');
};

const Linkable = (props) => {
  const string = props.children;
  if (string === null) return null;
  const delimiter = /((?:https?:\/\/)?(?:(?:[a-z0-9]?(?:[a-z0-9\-]{1,61}[a-z0-9])?\.[^\.|\s])+[a-z\.]*[a-z]+|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})(?::\d{1,5})*[a-z0-9.,_\/~#&=;%+?\-\\(\\)]*)/gi;

  return (
    <React.Fragment>
      {
        string.split(delimiter).map((word, i) => {
          const match = word.match(delimiter);
          if (!match) return (<span key={i}>{ word }</span>);
          const link = match[0];
          const url = link.startsWith('http') ? link : `http://${link}`
          return (<a href="url" key={i} target="_blank">{ decodeURI(url) }</a>);
        })
      }
    </React.Fragment>
  );
};

const MsgTime = (props) => {
  const { data } = props;
  const { time } = data;
  return (
    <time className="qca-chat-time">
      { time }
    </time>
  );
};

const MsgVideo = (props) => {
  const ref = useRef();
  const { data } = props;
  const [cover, setCover] = useState('');
  const [metaInfo, setMetaInfo] = useState({
    width: 0,
    height: 0,
    duration: '0:00',
  });

  useEffect(() => {
    const canvas = document.createElement('canvas');
    const video = ref.current;
    // const video = document.createElement('video');
    // video.setAttribute('crossOrigin', 'anonymous');
    // video.setAttribute('preload', 'auto');
    // video.setAttribute('src', data.url);
    new Promise((res) => {
      video.addEventListener('loadedmetadata', () => {
        const size = {
          width: video.videoWidth,
          height: video.videoHeight,
        }
        const n = Math.round(data.playLength || video.duration);
        const duration = [
          Math.floor(n / 60),
          `00${n % 60}`.slice(-2),
        ].join(':');
        setMetaInfo({ ...size, duration });
        res(size);
      });
    }).then((size) => {
      // video.addEventListener('loadeddata', () => {
      //   canvas.width = size.width;
      //   canvas.height = size.height;
      //   canvas.getContext('2d').drawImage(video, 0, 0, size.width, size.height);
      //   const image = canvas.toDataURL('image/jpeg');
      //   setCover(image);
      // });
    });
  }, []);

  return (
    <div className="qca-chat-media">
      <a href={data.url} target="_blank" rel="noopener noreferrer">
        {/* <img src={cover} alt="cover" className="qca-chat-cover" /> */}
        <video className="qca-chat-cover" ref={ref} src={data.url}></video>
        <div className="qca-chat-video-shadow">
          <SvgVideo className="qca-chat-icon-video" />
          <span className="qca-chat-duration">{ metaInfo.duration }</span>
        </div>
      </a>
    </div>
  );
};

const MsgImage = (props) => {
  const { data } = props;
  const url = fixUrl(data.url);
  const imgProps = {
    alt: 'image',
    className: 'qca-chat-image',
    src: url,
  };
  return (
    <div className="qca-chat-media">
      <a href={url} target="_blank" rel="noopener noreferrer">
        <img {...imgProps} />
      </a>
    </div>
  );
};

const MsgEmotion = (props) => {
  const { data } = props;
  const url = fixUrl(data.url);
  const imgProps = {
    alt: 'image',
    className: 'qca-chat-image',
    src: url,
  };
  return (
    <div className="qca-chat-media" style={{ display: 'inline-block' }}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <img {...imgProps} />
      </a>
    </div>
  );
};

const MsgFile = (props) => {
  const { data } = props;
  const name = data.filename;
  const ext = data.fileext;
  const size = data.filesize;
  const url = fixUrl(data.url);

  const handleDownloadFile = () => {
    window.open(url, '_blank');
    // window.location.href = url;
  };

  return (
    <div className="qca-chat-file">
      <SvgIconDownload
        className="qca-chat-file-download-icon"
        onClick={handleDownloadFile}
      />
      <div className="qca-chat-file-icon">
        <SvgFileExtIcon ext={ext} />
      </div>
      {/* <div className="qca-chat-file-name">{ `${name}.${ext} `}</div> */}
      <div className="qca-chat-file-name">{ name }</div>
      <div className="qca-chat-file-size">{ getSizeStr(size) }</div>
    </div>
  );
};

const MsgContent = (props) => {
  let { data } = props;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      console.error('text解析失败');
      data = { content: data };
    }
  }
  return (
    <div className="qca-chat-content">
      <Linkable>{ data.content }</Linkable>
    </div>
  );
};

const MsgLink = (props) => {
  const { data } = props;

  return (
    <div className="qca-chat-link">
      <a href={data.linkUrl} target="_blank" rel="noreferrer">
        <div className="qca-chat-link-title">{ data.title }</div>
        <div className="qca-chat-link-img">
          <img src={data.imgUrl} alt="img" />
        </div>
        <div className="qca-chat-link-description">{ data.description }</div>
      </a>
    </div>
  );
};

const MsgMixed = (props) => {
  const { data } = props;
  const items = data.items || [];
  const typeMap = {
    text: MsgContent,
    image: MsgImage,
    emotion: MsgEmotion,
  };

  return (
    <div className="qca-chat-mixed">
      {
        items.map((item, index) => {
          const Cpn = typeMap[item.type];
          if (!Cpn) return null;
          return (<Cpn key={index} data={item.content} />)
        })
      }
    </div>
  );
};

/**
 * 聊天框
 */
const ChatBox = (props) => {
  const ref = useRef();
  const box = useRef();
  const { employee, customer, query } = props;
  const notRoom = !customer.isRoom;
  const [chats, setChats] = useState(EMPTY_ARR);
  const [loading, setLoading] = useState(false);
  const [chatInitLoading, setChatInitLoading] = useState(true);

  // 用来进行渲染的数据，会比 chats 多一些 time 类型的数据
  const displayChats = useMemo(() => {
    const arr = [];
    if (chats.length < 1) return arr;
    const _chats = chats.concat();
    for (let i = 0, len = _chats.length; i < len; i++) {
      const prev = _.get(chats[i + 1], '_t', 0);
      const curr = _.get(chats[i], '_t', 0);
      arr.push(chats[i]);
      if (!prev || Math.abs(Math.floor((curr - prev) / 60000))) {
        arr.push({
          msgType: 'time',
          msgSeq: `${chats[i].msgSeq}-time`,
          msgContent: { time: displayTime(chats[i]._t) },
        });
      }
    }
    return arr.reverse();
  }, [chats]);

  const fetchChats = useCallback((params) => {
    const fetchFn = (res, rej) => {
      if ($xhr && $xhr.abort) $xhr.abort();
      $xhr = RPCFactory.qwArchive.getChat(params)
        .done((data) => {
          const list = data.chatList || [];
          const arr = list.map((item) => Object.assign(
            item,
            { _t: moment(item.msgTime).valueOf() },
          ));
          res(arr);
          setLoading(false);
        })
        .fail((ret, msg) => {
          if (msg === 'abort') return;
          rej(msg);
          setLoading(false);
          window.alert(msg);
        });
    };
    return new Promise(fetchFn);
  }, []);

  /**
   * 下拉加载更多数据
   * 由于是一次性拉取所有的记录，暂时用不到这个
   */
  const handleLoadMoreChats = () => {
    // TODO: 目前没有拉取的 limit 参数，是全量返回的聊天数据
    return;
    // setLoading(true);
    // const { start, end } = _.get(query, 'time', {});
    // const fetchParams = {
    //   wxWorkUserId1: employee,
    //   [customer.isRoom ? 'roomId' : 'wxWorkUserId2']: customer.customerId,
    //   startTime: moment(start || 0).format('YYYY-MM-DD HH:mm:ss'),
    //   endTime: moment(end).format('YYYY-MM-DD HH:mm:ss'),
    //   lastMsgSeq: _.get(_.last(chats), 'msgSeq'),
    // };
    // fetchChats(fetchParams).then((chatArr) => {
    //   // TODO: 对数据进行合并、排重
    // });
  };

  const handleScroll = (e) => {
    if (loading) return;
    const { target } = e;
    const { scrollTop, scrollHeight, clientHeight } = target;
    if (200 < scrollTop + scrollHeight - clientHeight || chats.length < 1) return;
    handleLoadMoreChats();
  };

  // 进入页面，拿到 id 和 query 执行第一次的初始化加载聊天记录
  useEffect(() => {
    setChats(EMPTY_ARR);
    if (!customer.customerId || !employee) {
      setChatInitLoading(false);
      return;
    };
    // console.log('客户切换 or 日期变更，获取新数据');
    const { start, end } = _.get(query, 'time', {});
    const fetchParams = {
      wxWorkUserId1: employee,
      [customer.isRoom ? 'roomId' : 'wxWorkUserId2']: customer.customerId,
      startTime: moment(start || 0).format('YYYY-MM-DD HH:mm:ss'),
      endTime: moment(end).format('YYYY-MM-DD HH:mm:ss'),
      lastMsgSeq: undefined,
    };
    fetchChats(fetchParams).then((chatArr) => {
      setChats(chatArr);
      setChatInitLoading(false);
    }).catch((msg) => {
      setChatInitLoading(false);
      window.alert(msg);
    });
  }, [employee, customer, query, fetchChats]);

  // 切换用户之后先清空聊天记录
  useEffect(() => {
    if (!customer.customerId) return;
    setChats(EMPTY_ARR);
    setChatInitLoading(true);
  }, [customer]);

  if (chatInitLoading) {
    return (
      <div className="qca-chat-container">
        <div className="qca-chat-empty">
          <img src={BASE64_EMPTY_CHAT} alt="empty" />
          <p className="qca-chat-empty-text">加载中&nbsp;</p>
        </div>
      </div>
    );
  }

  if (!customer.customerId || displayChats.length < 1) {
  // if (true) {
    return (
      <div className="qca-chat-container">
        <div className="qca-chat-empty">
          <img src={BASE64_EMPTY_CHAT} alt="empty" />
          <p className="qca-chat-empty-text">暂无对话&nbsp;</p>
        </div>
      </div>
    );
  }

  return (
    <div className="qca-chat-container" ref={ref} onScroll={handleScroll}>
      <div
        ref={box}
        className={classNames('qca-chat-box', { 'not-room': notRoom })}
      >
        {
          displayChats.map((item) => {
            const key = item.msgSeq;
            const type = item.msgType;
            const data = item.msgContent;
            const map = {
              time: MsgTime,
              text: MsgContent,
              image: MsgImage,
              emotion: MsgEmotion,
              video: MsgVideo,
              file: MsgFile,
              mixed: MsgMixed,
              link: MsgLink,
            };
            const Component = map[type];
            if (!Component) return null;
            if (type === 'time') {
              return (<Component key={key} data={data} />);
            }
            const classname = classNames(
              'qca-chat-msg',
              { 'my-msg': item.from === employee },
            );
            return (
              <div key={key} className={classname}>
                <div className="qca-chat-name">{ item.fromName }</div>
                <Component data={data} />
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

export default ChatBox;
